/*
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { enableHeatMaps, switchToRlContours, switchToFlContours, disableHeatMaps } from '../../../../store/maps/actions';
import { GOOGLE_MAP_INSTANCE_KEY } from '../../../common/map/GoogleMapSingleton';
import { ContourDisplayEnum } from '../PerformanceOutlookExportModal';

export const useHeatMapsEnabled = (contourDisplayType: ContourDisplayEnum, mapId = GOOGLE_MAP_INSTANCE_KEY) => {
    const dispatch = useDispatch();
    
    useEffect(() => {
      if (contourDisplayType === ContourDisplayEnum.RL || contourDisplayType === ContourDisplayEnum.FL) {
        dispatch(enableHeatMaps(mapId)());
  
        if (contourDisplayType === ContourDisplayEnum.RL) {
          dispatch(switchToRlContours(mapId)());
        } else if (contourDisplayType === ContourDisplayEnum.FL) {
          dispatch(switchToFlContours(mapId)());
        }
      } else {
        dispatch(disableHeatMaps(mapId)());
      }
    }, [contourDisplayType, mapId, dispatch]);
  }